import { AgGridReact } from 'ag-grid-react'; // React Grid Logic
import "ag-grid-community/styles/ag-grid.css"; // Core CSS
import "ag-grid-community/styles/ag-theme-quartz.css"; // Theme
import {  useState, useMemo } from "react"
import './Grid.css';

function Grid (props) {
  const [rowData, setRowData] = useState(props.data);
  const [columnDefs, setColumnDefs] = useState(props.cols.map(col => ({
    headerName: col.title,
    field: col.field,
    sortable: true,
    filter: true,
    resizable: true
  })));
  const defaultColDef = useMemo(() => {
    return {
      resizable: false,
    };
  }, []);
  const autoSizeStrategy = {
    type: 'fitGridWidth',
    defaultMinWidth: 100
  };

  return (
    <div
      class="grid-style"
    >
      <div className="table-title">
        <a href="#" className="link-title">{props.name}</a>
      </div>
      {/*<h3>Dados das Linhas:</h3>*/}
      {/*<pre>{JSON.stringify(rowData, null, 2)}</pre>*/}

      {/*<h3>Definições das Colunas:</h3>*/}
      {/*<pre>{JSON.stringify(columnDefs, null, 2)}</pre>*/}
      <AgGridReact
        className={"ag-theme-quartz"}
        defaultColDef={defaultColDef}
        domLayout='autoHeight'
        rowData={rowData}
        columnDefs={columnDefs}
        autoSizeStrategy={autoSizeStrategy}
      />
    </div>
  );
};

export default Grid;